// components/LogoutButton.js
import React from 'react';
import { LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const LogoutButton = ({ className = '' }) => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        // Clear any other stored data if needed
        navigate('/admin/login', { replace: true });
    };

    return (
        <button
            onClick={handleLogout}
            className={`flex items-center gap-2 px-4 py-2 bg-red-500 hover:bg-red-500/30 text-white rounded-lg smooth-transition ${className}`}
            title="Cerrar sesión"
        >
            <LogOut size={18} />
            <span>Cerrar Sesión</span>
        </button>
    );
};

export default LogoutButton;